import { inject, InjectionToken } from '@angular/core';
import { ToastService } from '../services';
import { Observable } from 'rxjs';
import { ToastOptions } from '@ionic/angular';

export const TOAST_TOKEN: InjectionToken<ToastProvider> = new InjectionToken<ToastProvider>('TOAST_TOKEN', {
  factory: (): ToastProvider => {
    const toastService: ToastService = inject(ToastService);
    const buildOpts = (opts: ToastOptions): ToastOptions => ({ duration: 3000, position: 'bottom', ...opts });

    return {
      showToast$(opts: ToastOptions): Observable<void> {
        return toastService.showToast(buildOpts(opts));
      },
      showToast(opts: ToastOptions): void {
        toastService.presentToast(buildOpts(opts));
      }
    };
  }
});

export interface ToastProvider {
  showToast$(opts: ToastOptions): Observable<void>;
  showToast(opts: ToastOptions): void;
}
